import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {zh} from './lang/zh'
import {en} from './lang/en'
import iviewZh from 'iview/dist/locale/zh-CN'
import iviewEn from 'iview/dist/locale/en-US'

Vue.use(VueI18n)
Vue.locale = () => { }

const messages = {
    en: Object.assign(en, iviewEn),
    zh: Object.assign(zh, iviewZh)
}

const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'zh',
    messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/translations/i18n.js